module.exports = __webpack_public_path__ + "static/media/marker_temporary_bus_stop_green_selected.398de87b.svg";